import { ActionCreator, ReducerTypes, on } from '@ngrx/store'
import { loadActivities, loadActivitiesSuccess, loadActivitiesFailure } from '../actions/activity.actions'
import { updateInterventionSuccess, deleteInterventionSuccess } from '../actions/intervention.actions'
import { CropActivity, Intervention } from '@agroone/entities'
import { CropDetailActivities, CropDetailState, cropDetailAdapter } from './crop-detail.reducer'

export const activityOns: ReducerTypes<CropDetailState, ActionCreator[]>[] = [
  on(loadActivities, (state) => ({
    ...state,
    loading: true,
  })),
  on(loadActivitiesSuccess, (state, { cropId, activities }) => {
    const cropDetail = state.entities[cropId]
    if (cropDetail) {
      const updatedParent: CropDetailActivities = {
        ...cropDetail,
        activities: [...activities],
      }

      return cropDetailAdapter.updateOne({ id: cropId, changes: updatedParent }, state)
    }

    return state
  }),
  on(loadActivitiesFailure, (state) => ({
    ...state,
  })),
  // Keep activities array in sync when an intervention is updated
  on(updateInterventionSuccess, (state, { payload: { cropId, intervention } }) => {
    const cropDetail = state.entities[`${cropId}`]
    if (!cropDetail || !cropDetail.activities) {
      return state
    }

    const updatedActivities: CropActivity[] = cropDetail.activities.map((act) => {
      if (act?.type === Intervention.className && act?.activity?.id === intervention.id) {
        return {
          ...act,
          activity: intervention,
        }
      }
      return act
    })

    const updatedParent: CropDetailActivities = {
      ...cropDetail,
      activities: updatedActivities,
    }

    return cropDetailAdapter.updateOne({ id: cropDetail.cropId, changes: updatedParent }, state)
  }),
  // Remove activity item when an intervention is deleted
  on(deleteInterventionSuccess, (state, { cropId, interventionId }) => {
    const cropDetail = state.entities[cropId]
    if (!cropDetail || !cropDetail.activities) {
      return state
    }

    const updatedParent: CropDetailActivities = {
      ...cropDetail,
      activities: cropDetail.activities.filter(
        (act) => !(act?.type === Intervention.className && act?.activity?.id === interventionId),
      ),
    }

    return cropDetailAdapter.updateOne({ id: cropId, changes: updatedParent }, state)
  }),
]
